import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { NotificationCardStyleProps} from './NotificationCard.interface';

export const Wrapper = styled.div<NotificationCardStyleProps>`
    width: 380px;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing * 3}px 
        ${({ theme }) => theme.spacing * 6}px;
    border-radius: 6px;
    background-color: ${props => props.isRead ? '#9daec014' : '#9daec033'};
    margin: 12px 0;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const Date = styled.p`
    margin: 0;
    opacity: .87;
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
`;

export const CampaignTitle = styled.h1`
    margin: 0;
    opacity: .87;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.blue};
`;

export const NotificationInfo = styled.p`
    margin: ${({ theme }) => theme.spacing}px 0;
    opacity: .87;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.blue};
`;

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledIconButton = styled(IconButton)`
    && {
        padding: 0;
        > span > svg {
            width: 16px;
            color: ${({ theme }) => theme.colors.blue};
            opacity: .54;
        }
    }
`;

export const Redirect = styled.div`
    cursor: pointer;
`;
